export default "__VITE_ASSET__CAOe8bcD__"